<template>
  <div class="main">
    <!-- Left -->
    <div class="main_l">
      <!-- 组织架构 -->
      <Organization @change="changeOrganization"></Organization>
    </div>
    <!-- Left End -->

    <!-- Right -->
    <div class="main_r">
      <div class="title">用户管理列表</div>
      <!-- search -->
      <div class="search">
        <div>
          <el-input v-model="keyword"  placeholder="查找人员名称"></el-input>
          <el-select v-model="role_id" placeholder="角色">
            <el-option label="请选择角色" value="-1"></el-option>
            <el-option v-for="item in role_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="user_status" placeholder="人员状态">
            <el-option label="请选择人员状态" value="-1"></el-option>
            <el-option label="在职" value="1"></el-option>
            <el-option label="离职" value="0"></el-option>
          </el-select>
          <el-button type="primary" @click="clickQuery">查询</el-button>
          <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
        </div>
        <el-button type="primary" @click="clickdialogAddUser">新增</el-button>
      </div>
      <!-- search End -->

      <!-- 列表 -->
      <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
        <el-table-column prop="id" label="序号" width="80" sortable="custom"></el-table-column>
        <el-table-column prop="userLogin" label="登录账号" sortable="custom"></el-table-column>
        <el-table-column prop="userName" label="人员姓名" sortable="custom"></el-table-column>
        <el-table-column prop="userPhone" label="联系方式" sortable="custom"></el-table-column>
        <el-table-column prop="Role" label="角色" sortable="custom">
          <template slot-scope="props">
            <span v-for="item in role_list" :key="item.id" v-if="item.id == props.row.roleId">{{item.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userStatus" label="人员状态" sortable="custom">
          <template slot-scope="props">
            <span v-if="props.row.userStatus == 1">在职</span>
            <span v-if="props.row.userStatus == 0">离职</span>
          </template>
        </el-table-column>
        <el-table-column prop="Operation" label="操作" width="100">
          <template slot-scope="props">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
              <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(props.row)"></el-link>
            </el-tooltip>
            <el-tooltip v-if="props.row.userStatus == 0" class="item" effect="dark" content="离职" placement="top" :enterable="false">
              <el-link :underline="false" icon="el-icon-lock" @click="ClickLock(props.row,1)"></el-link>
            </el-tooltip>
            <el-tooltip v-if="props.row.userStatus == 1" class="item" effect="dark" content="在职" placement="top" :enterable="false">
              <el-link :underline="false" type="primary" icon="el-icon-unlock" @click="ClickLock(props.row,0)"></el-link>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="mt20">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="10"
          layout="prev, pager, next, sizes, jumper "
          :total="dataListnum">
        </el-pagination>
      </div>
      <!-- 分页 End -->
    </div>
    <!-- Right End -->

    <!---------------------- 以下是弹框内容 ---------------------->
    <!-- 新增用户 -->
    <el-dialog title="添加人员" :visible.sync="dialogAddUser" width="26%" class="newAdd">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="addData" label-width="80px">
          <el-form-item label="账号" :required=true>
            <el-input v-model="addData.userLogin" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" :required=true>
            <el-input v-model="addData.userPassword" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="姓名" :required=true>
            <el-input v-model="addData.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" :required=true>
            <el-input v-model="addData.userPhone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="角色" :required=true>
            <el-select v-model="addData.roleId" placeholder="角色">
              <el-option label="请选择" value="-1"></el-option>
              <el-option v-for="item in role_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addUser()" >确 认</el-button>
        <el-button @click="dialogAddUser = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 新增用户 End -->

    <!-- 编辑信息 -->
    <el-dialog title="编辑信息" :visible.sync="dialogEdit" width="26%" class="newAdd">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="editData" label-width="80px">
          <el-form-item label="密码">
            <el-input v-model="editData.userPassword" placeholder="仅需修改密码时填写"></el-input>
          </el-form-item>
          <el-form-item label="姓名" :required=true>
            <el-input v-model="editData.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" :required=true>
            <el-input v-model="editData.userPhone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="角色" :required=true>
            <el-select v-model="editData.roleId" placeholder="角色">
              <el-option label="请选择" value="-1"></el-option>
              <el-option v-for="item in role_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editUser()" >确 认</el-button>
        <el-button @click="dialogEdit = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑信息 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import Organization from '@/components/Organization.vue' // 组织架构
Vue.use(VueAxios, axios)

export default {
  components: { Organization },
  data () {
    return {
      formLabelWidth: '120px',
      keyword: '',
      role_list: [],
      role_id: '-1',
      user_status: '-1',
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      organizationId: '',
      // 新增
      dialogAddUser: false,
      addData: {
        userLogin: '',
        userPassword: '',
        userName: '',
        userPhone: '',
        roleId: ''
      },
      // 编辑
      dialogEdit: false,
      editData: {
        editId: '',
        userPassword: '',
        userName: '',
        userPhone: '',
        roleId: ''
      }
    }
  },
  mounted () {
    this.listRole()
  },
  methods: {
    handleSizeChange (val) {
      this.page_size = val
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    handleSortChange ({ prop, order }) {
      const fieldMap = {
        'Role': 'roleId'
      }
      this.sortField = fieldMap[prop] || prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    changeOrganization (node) {
      this.organizationId = node.id
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    clickQuery () {
      this.page_no = 1
      this.getUsersByCombinationConditions()
      this.getUsersNumByCombinationConditions()
    },
    clickQueryReset () {
      this.keyword = ''
      this.role_id = '-1'
      this.user_status = '-1'
      this.clickQuery()
    },
    clickdialogAddUser () {
      this.dialogAddUser = true
      this.addData.userLogin = ''
      this.addData.userPassword = ''
      this.addData.userName = ''
      this.addData.userPhone = ''
      this.addData.roleId = ''
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.editId = row.id
      this.editData.userPassword = ''
      this.editData.userName = row.userName
      this.editData.userPhone = row.userPhone
      this.editData.roleId = row.roleId
    },
    ClickLock (row, userStatus) {
      this.editUserStatus(row.id, userStatus)
    },
    listRole: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_listRole, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.role_list = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getUsersByCombinationConditions: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.organizationId = that.organizationId
      data.keyword = that.keyword
      data.roleId = that.role_id
      data.userStatus = that.user_status
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getUsersByCombinationConditions, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getUsersNumByCombinationConditions: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.organizationId = that.organizationId
      data.keyword = that.keyword
      data.roleId = that.role_id
      data.userStatus = that.user_status
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getUsersNumByCombinationConditions, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    addUser: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.userLogin = that.addData.userLogin
      data.userPassword = that.addData.userPassword
      data.userName = that.addData.userName
      data.userPhone = that.addData.userPhone
      data.organizationId = that.organizationId
      data.roleId = that.addData.roleId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_addUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.getUsersByCombinationConditions()
            that.getUsersNumByCombinationConditions()
            that.dialogAddUser = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAddUser = false
        })
    },
    editUser: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.editId = that.editData.editId
      data.userPassword = that.editData.userPassword
      data.userName = that.editData.userName
      data.userPhone = that.editData.userPhone
      data.roleId = that.editData.roleId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_editUser, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.getUsersByCombinationConditions()
            that.getUsersNumByCombinationConditions()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    editUserStatus: function (editId, userStatus) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.editId = editId
      data.userStatus = userStatus
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_editUserStatus, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.getUsersByCombinationConditions()
            that.getUsersNumByCombinationConditions()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>
